import * as React from 'react';
import { useSettingsContext } from '../contexts/settings';
import Default from './cards/Default';
import { useFiltersContext } from '../contexts/filters';
import Resource from './cards/Resource';
const { __ } = wp.i18n;

const PostsGrid = ({ posts, foundPosts, setLoadingHeight }) => {
	const tableRef = React.useRef(false);
	const settings = useSettingsContext();
	const { searchQuery } = useFiltersContext();

	React.useEffect(() => {
		if (tableRef.current.offsetHeight) {
			setLoadingHeight(`${tableRef.current.offsetHeight}px`);
		} else {
			setLoadingHeight(null);
		}
	}, [posts, setLoadingHeight]);

	if (posts.length) {
		return (
			<>
				{searchQuery.length > 0 && foundPosts > 0 && (
					<h3 className="pfa-results-found supertext">
						{foundPosts} {__('Result', 'wex')}
						{foundPosts > 1 && 's'} {__('Found', 'wex')}
					</h3>
				)}
				<div
					ref={tableRef}
					className={`pfa-posts-grid pfa-posts-grid--${settings.postType}`}
					role="region"
					aria-label="Filterable posts"
				>
					{posts.map((post) => {
						switch (post.post_type) {
							case 'resource': {
								return <Resource post={post} key={post.ID} />;
							}
							default: {
								return <Default post={post} key={post.ID} />;
							}
						}
					})}
				</div>
			</>
		);
	}
};

PostsGrid.displayName = 'PostsGrid';

export default PostsGrid;
